(function () {
    'use strict';

    angular
        .module('app.floorPlans')
        .controller('FloorPlanDetailsController', FloorPlanDetailsController);

    FloorPlanDetailsController.$inject = [
        '$state', '$stateParams', '$window',
        'bootstrap.dialog', 'common', 'dataservice', '$sce'
    ];

    function FloorPlanDetailsController($state, $stateParams, $window, bsDialog, common, dataservice, $sce) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = {};
        vm.trustedSvg = trustedSvg;
        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItem()];
           
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function trustedSvg() {
            return $sce.trustAsHtml(vm.item.SvgData);
        };

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("floorplans.list");
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Floor Plan')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/FloorPlans/" + vm.item.ID).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '') {
                vm.item = {};
                vm.item.ID = '';
                common.setAuditInfo(vm.item);
                return vm.item;
            }
            else {
                return dataservice.getItem("api/FloorPlans/" + val)
                    .then(function (data) {
                        if (data) {
                            vm.item = data.data;
                            common.setAuditInfo(vm.item);

                        } else {
                            logger.warning('Could not find item with id = ' + val);
                            $state.go('404');
                        }
                    })
                    .catch(function (error) {
                        logger.error('Error while getting item with id = ' + val + '; ' + error);
                        $state.go('404');
                    });
            }
        }

        function save() {
            vm.isSaving = true;

            dataservice.saveItem('api/FloorPlans/Save', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                common.logger.error(error);
                vm.isSaving = false;
            });
        }
    }
})();
